/**
 * 行の承認者（選んだ人。選んでいなければ初期値＝案件の責任者）を決める。
 *
 * candidates を渡すと、承認者の候補（欄の選択肢）にいない人を「まだ選んでいない」と
 * して null にする（2026-10-09）。案件の責任者が、無効になった・承認する権限を
 * 外れたなどで候補にいないと、欄は選択肢に無い値を持ったまま空白に見え、選ばずに
 * ［申請］するとその人の番号を送って、サーバに必ず断られていた。
 * 候補にいるかどうかは、欄に並べる選択肢そのもので見る（別の数え方を作らない）。
 *
 * candidates を渡さない（まだ読めていない・承認待ちで欄を固定している行）ときは、
 * 候補では絞らない。
 */
export function resolveSubmissionApproverId(item, candidates) {
  if (!item) return null;

  const id = item.approver_user_id === null
    ? item.user_id
    : item.approver_user_id;
  // 選んだ承認者も、初期値（案件の責任者）も無い行は「まだ選んでいない」。
  // 欄の「選択してください」と合うように、値が無いときは null にそろえる。
  if (id === undefined || id === null) return null;
  if (!Array.isArray(candidates)) return id;

  const candidate = candidates.find(option =>
    option && option.id !== undefined && option.id !== null &&
    String(option.id) === String(id)
  );
  // 欄の選択肢と同じ値で返す（型が違うと、欄がその選択肢を選んだ形にならない）。
  return candidate ? candidate.id : null;
}

/**
 * 一覧の各行の承認者。
 *
 * candidatesOf は、行ごとに「絞るのに使う候補」を返す関数（絞らない行は undefined を返す）。
 * 渡さなければ、どの行も候補では絞らない。
 */
export function resolveSubmissionApproverSelections(items, candidatesOf) {
  return (Array.isArray(items) ? items : []).map(item =>
    resolveSubmissionApproverId(
      item,
      typeof candidatesOf === 'function' ? candidatesOf(item) : undefined
    )
  );
}
